import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Facebook",
  "use": "Facebook-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"Facebook\">\n<circle cx=\"12\" cy=\"12\" r=\"12\" fill=\"#3D5A96\" />\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.8119 16.9233H10.6293V12.2739H9.53857V10.4821H10.6293V9.40735C10.6293 7.94673 11.2451 7.07715 12.9948 7.07715H14.4513V8.86885H13.5412C12.8599 8.86885 12.8146 9.11894 12.8146 9.5863L12.8119 10.4821H14.4617L14.2684 12.2739H12.8119V16.9233V16.9233Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol